import { businessDateTimeToDate } from "@zapis24/utils";

export type ManualAppointmentClientMode = "existing" | "new";

export interface ManualAppointmentFormState {
  serviceId: string;
  date: string;
  time: string;
  clientMode: ManualAppointmentClientMode;
  clientId: string;
  clientName: string;
  clientPhone: string;
  notes: string;
}

export interface ManualAppointmentPayload {
  serviceId: string;
  startsAt: string;
  source: "ADMIN_PANEL";
  clientId?: string;
  clientName?: string;
  clientPhone?: string;
  notes?: string;
}

export interface ManualAppointmentSlot {
  timeStr: string;
}

interface BusinessTimeZoneOptions {
  timeZone?: string;
}

export const EMPTY_MANUAL_APPOINTMENT_FORM: ManualAppointmentFormState = {
  serviceId: "",
  date: "",
  time: "",
  clientMode: "new",
  clientId: "",
  clientName: "",
  clientPhone: "",
  notes: "",
};

export function getManualAppointmentValidationError(
  form: ManualAppointmentFormState
): string | null {
  if (!form.serviceId) return "Выберите услугу";
  if (!form.date) return "Выберите дату";
  if (!form.time) return "Выберите время";

  if (form.clientMode === "existing") {
    return form.clientId ? null : "Выберите клиента";
  }

  if (!form.clientName.trim()) return "Укажите имя клиента";
  if (!form.clientPhone.trim()) return "Укажите телефон клиента";
  return null;
}

export function filterFutureSlotsForDate<TSlot extends ManualAppointmentSlot>(
  slots: readonly TSlot[],
  date: string,
  now = new Date(),
  options: BusinessTimeZoneOptions = {},
): TSlot[] {
  if (!date) return [...slots];

  return slots.filter((slot) => {
    const [year, month, day] = date.split("-").map(Number) as [number, number, number];
    const [hour, minute] = slot.timeStr.split(":").map(Number) as [number, number];
    const slotStartsAt = businessDateTimeToDate(
      `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
      `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`,
      options.timeZone,
    );

    if (Number.isNaN(slotStartsAt.getTime())) return true;
    return slotStartsAt.getTime() > now.getTime();
  });
}

export function buildManualAppointmentPayload(
  form: ManualAppointmentFormState,
  options: BusinessTimeZoneOptions = {},
): ManualAppointmentPayload {
  const payload: ManualAppointmentPayload = {
    serviceId: form.serviceId,
    startsAt: businessDateTimeToDate(form.date, form.time, options.timeZone).toISOString(),
    source: "ADMIN_PANEL",
  };

  if (form.clientMode === "existing") {
    payload.clientId = form.clientId;
  } else {
    payload.clientName = form.clientName.trim();
    payload.clientPhone = form.clientPhone.trim();
  }

  const notes = form.notes.trim();
  if (notes) payload.notes = notes;

  return payload;
}
